import React from 'react';

import { useQuery } from '@apollo/client';
import { ApolloClientName } from '@/config/apolloClient';
import { GET_LINKED_ACCOUNTS } from '@/graphql/queries';
import { LinkedAccount } from '@/graphql/types';

export type LinkedAccounts = {
  linkedAccounts: LinkedAccount[];
  loading: boolean;
};

export const useLinkedAccounts = (): LinkedAccounts => {
  const { loading, data } = useQuery<{
    profile: { linkedAccounts: LinkedAccount[]; loading: boolean };
  }>(GET_LINKED_ACCOUNTS, {
    context: {
      clientName: ApolloClientName.AccountsBff,
    },
    fetchPolicy: 'network-only',
  });

  return { linkedAccounts: data?.profile?.linkedAccounts ?? [], loading };
};
